import { gql } from 'urql'

export const CONSOLIDATOR_FEATURE_FLAG_QUERY = gql`
	query ConsolidatorFeatureFlag($name: String!) {
		consolidatorFeatureFlag(name: $name)
	}
`

export type ConsolidatorFeatureFlagQueryResult = {
	consolidatorFeatureFlag: boolean
}

export type ConsolidatorFeatureFlagQueryVariables = {
	name: string
}
